var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather10N(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xA0icon-10n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-icon-10n",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#373E42",
    fill: "#605F5E",
    strokeLinecap: "square",
    cx: 43.8709677,
    cy: 14.9166667,
    rx: 12.8709677,
    ry: 12.9166667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 9.000000)",
    fill: "#59A5D8",
    stroke: "#0A6EAC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7951441,23.1112682 C31.4943229,24.343411 29.710606,25.1034483 27.7427184,25.1034483 C26.1354492,25.1034483 24.651036,24.5964439 23.4522351,23.7393107 C22.1341459,25.1286132 20.2381832,26 18.131068,26 C15.4373309,26 13.0886821,24.575886 11.8513116,22.4661646 C10.644793,23.2831012 9.19933374,23.7586207 7.64563107,23.7586207 C3.42306563,23.7586207 0,20.2463717 0,15.9137931 C0,11.9010161 2.9363807,8.59193595 6.72471042,8.12529128 C7.44106451,5.0152392 10.319835,2.68965517 13.7621359,2.68965517 C15.0514056,2.68965517 16.2616243,3.01588369 17.3087876,3.58737147 C19.3887735,1.38566332 22.4118831,0 25.776699,0 C31.2387191,0 35.8003363,3.65125098 36.8890702,8.5172888 C36.8985349,8.51725719 36.9080034,8.51724138 36.9174757,8.51724138 C41.3813306,8.51724138 45,12.0294903 45,16.362069 C45,20.6946476 41.3813306,24.2068966 36.9174757,24.2068966 C35.4117081,24.2068966 34.0021123,23.8072454 32.7951441,23.1112682 Z",
    id: "Combined-Shape-Copy-3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,38 C10.6568542,38 12,36.3345147 12,34.2800344 C12,32.9103809 11,30.8170361 9,28 C7,30.8170361 6,32.9103809 6,34.2800344 C6,36.3345147 7.34314575,38 9,38 Z",
    id: "Oval-11",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,47 C22.6568542,47 24,45.3345147 24,43.2800344 C24,41.9103809 23,39.8170361 21,37 C19,39.8170361 18,41.9103809 18,43.2800344 C18,45.3345147 19.3431458,47 21,47 Z",
    id: "Oval-11-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,39 C34.6568542,39 36,37.3345147 36,35.2800344 C36,33.9103809 35,31.8170361 33,29 C31,31.8170361 30,33.9103809 30,35.2800344 C30,37.3345147 31.3431458,39 33,39 Z",
    id: "Oval-11-Copy-2",
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather10N);
export default __webpack_public_path__ + "static/media/icon-weather-10n.e3da4def13cb63168eebc7f9774ead01.svg";
export { ForwardRef as ReactComponent };